module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ambis-meter"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Meter'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("List Periode Ambis Meter")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Periode Ambis Meter\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    on: {
      "click": function($event) {
        return _vm.createAmbisMeter()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Ambis Meter\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    key: _vm.tableKey,
    attrs: {
      "items": _vm.ambismeters,
      "headers": _vm.headers,
      "has-action": true,
      "has-leaderboard": true,
      "customWidth": true,
      "custom-pagination-total-items": _vm.ambismeters.length,
      "custom-pagination-per-page": 10,
      "custom-pagination-current-page": 1,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editAmbisMeter()
      },
      "duplicateClicked": function($event) {
        return _vm.duplicateAmbisMeter()
      },
      "leaderboardClicked": function($event) {
        return _vm.goToLeaderboard()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433b7c7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/AmbisMeter.vue
// module id = 947
// module chunks = 1